import * as I18n from 'i18n-js';
import * as React from 'react';
import * as classNames from 'classnames';

const USD = 'USD';

interface Props {
  amountCents?: number;
  currency: string;
  display: string;
  showFree?: boolean;
  auction?: boolean;
}

export default class PriceDisplay extends React.Component<Props, null> {
  shouldShowFree() {
    return this.props.showFree && this.props.amountCents === 0;
  }

  shouldShowMessage() {
    return !!this.props.showFree || !!this.props.auction;
  }

  currencyDisplay() {
    if (this.shouldShowMessage()) return null;

    if (this.props.currency !== USD) {
      return <span className="price-display__currency">{this.props.currency}</span>;
    }

    return null;
  }

  getText() {
    if (this.props.auction) return I18n.t('commons.auction');
    if (this.shouldShowFree()) return I18n.t('commons.free');

    return this.props.display;
  }

  render() {
    if (!this.props.display) return null;
    const classes = classNames(
      'price-display',
      { 'price-display--message': this.shouldShowMessage() },
    );

    return (
      <span className={classes}>
        {this.getText()}
        {this.currencyDisplay()}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/price_display.tsx